export default "__VITE_ASSET__Co4Uu1of__"